/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    UserAdminAllOf,
    UserAdminAllOfFromJSON,
    UserAdminAllOfToJSON,
    UserMeWithBalance,
    UserMeWithBalanceFromJSON,
    UserMeWithBalanceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserAdmin
 */
export interface UserAdmin {
    /**
     * 
     * @type {string}
     * @memberof UserAdmin
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdmin
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    isMod?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UserAdmin
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof UserAdmin
     */
    pic?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    isExternal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserAdmin
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    emailVerified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    emailNotify: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    iosPush: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    androidPush: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    browserPush: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdmin
     */
    hasPassword: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserAdmin
     */
    intercomIdentity?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserAdmin
     */
    categorySubscriptions?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UserAdmin
     */
    balance: number;
}

export function UserAdminFromJSON(json: any): UserAdmin {
    return {
        'userId': json['userId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isMod': !exists(json, 'isMod') ? undefined : json['isMod'],
        'created': new Date(json['created']),
        'pic': !exists(json, 'pic') ? undefined : json['pic'],
        'isExternal': !exists(json, 'isExternal') ? undefined : json['isExternal'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'emailVerified': !exists(json, 'emailVerified') ? undefined : json['emailVerified'],
        'emailNotify': json['emailNotify'],
        'iosPush': json['iosPush'],
        'androidPush': json['androidPush'],
        'browserPush': json['browserPush'],
        'hasPassword': json['hasPassword'],
        'intercomIdentity': !exists(json, 'intercomIdentity') ? undefined : json['intercomIdentity'],
        'categorySubscriptions': !exists(json, 'categorySubscriptions') ? undefined : json['categorySubscriptions'],
        'balance': json['balance'],
    };
}

export function UserAdminToJSON(value?: UserAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'userId': value.userId,
        'name': value.name,
        'isMod': value.isMod,
        'created': value.created.toISOString(),
        'pic': value.pic,
        'isExternal': value.isExternal,
        'email': value.email,
        'emailVerified': value.emailVerified,
        'emailNotify': value.emailNotify,
        'iosPush': value.iosPush,
        'androidPush': value.androidPush,
        'browserPush': value.browserPush,
        'hasPassword': value.hasPassword,
        'intercomIdentity': value.intercomIdentity,
        'categorySubscriptions': value.categorySubscriptions,
        'balance': value.balance,
    };
}


